import { setDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function saveOrganization(organization) {
  await setDoc(refs.organization(organization.id), organization)
  return organization
}
